import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchContactDetails } from "../../redux/actions/contactAction";

export default function ContactContainer() {
    const dispatch = useDispatch();
    const { id } = useParams();
    const [data, setData] = useState({});

    useEffect(() => {
        if (id) {
            dispatch(
                fetchContactDetails(id, (res) => {
                    setData({ ...res });
                })
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, dispatch]);



    return {
        data,
    };
}
